<template>
    <div
        v-if="rightSlotName !== ''"
        class="right-slot-header"
    >
        <div class="header">
            <h1
                v-if="displaySmallOrExtraSmall"
                class="filtering"
                :class="{'heading-space': !showFilteringSubtext}"
            >
                {{ rightSlotName }}
            </h1>
            <h2 class="right-slot-heading">
                <span
                    v-if="!displaySmallOrExtraSmall"
                    class="filtering header-span-spacing"
                    :class="{'heading-space': !showFilteringSubtext}"
                >{{ rightSlotName }}</span>
                <span
                    v-if="selectedDropDownText !== ''"
                    class="filtering-subtext"
                    :class="{'header-span-spacing': showFilteringSubtext}"
                >{{ selectedDropDownText }}</span>
                <span
                    v-if="showFilteringSubtext"
                    class="filtering-subtext"
                    :class="{'header-last-span-spacing': !displaySmallOrExtraSmall}"
                >{{ selectedAreaName }}</span>
            </h2>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-facing-decorator"
    import DynamicRightSlotData from "@/models/dynamicrighslotdata"
    import MunicipalitiesAndRegionsModel from "../models/municipalitiesandregionsmodel"

    @Component
    export default class RightSlotHeaderTemplate extends Vue {
        // Storen kautta haetaan, mitä  halutaan näyttää
        get rightSlotName(): string | undefined {
            let name: string|undefined = ""
            if (this.$store.getters.rightSlot === "Infokartat") {
                // Haetaan infokartan lokalisoitu nimi RadioButtonModelista
                const selectedSubjectRadioButton = this.$store.getters.selectedSubjectRadioButton
                if (selectedSubjectRadioButton !== undefined) {
                    name = selectedSubjectRadioButton.labelText
                }
            }
            else {
                // Palautetaan tyhjä string jos rightslotia ei ole asetettu niin etusivun righslotiin ei tulostu turhaa
                name = this.$store.getters.rightSlot === "" ? "" : this.$t("App.RightSlotHeaderTemplate." + this.$store.getters.rightSlot + "Header")
            }
            return name ?? ""
        }

        get rightSlotData(): DynamicRightSlotData | null {
            return (this.$store.getters.rightSlotData as DynamicRightSlotData)
        }

        get selectedDropDownText(): string | undefined {
            const rightSlotHeaderName = this.$store.getters.dataUrlToLoad?.rightSlotHeaderName ?? undefined

            if (rightSlotHeaderName) {
                return this.$t(this.$store.getters.dataUrlToLoad.rightSlotHeaderName)
            }
            else {
                    return this.$t(this.$store.getters.selectedDropDownResourceKey)
                }
            }

        // näytä teksti mikäli rightSlotData ja rightSlotData.municipality ei ole null ja mikäli valittu aihe sisältää kunta/maakunta/koko suomi valinnan
        get showFilteringSubtext(): boolean {
            return this.rightSlotData !== null
                && this.rightSlotData !== undefined
                && this.rightSlotData.municipality !== null
                && this.rightSlotData.municipality !== " "
                && this.$store.getters.rightSlot !== "Laajakaistahankkeet"
                && this.$store.getters.rightSlot !== "OikeusPuhelinJaLaajakaistaLiittymaan"
                && this.$store.getters.rightSlot !== "OikeusPuhelinJaLaajakaistaLiittymaanPalvelutyypinMukaan"
                && this.$store.getters.rightSlot !== "OikeusPuhelinJaLaajakaistaLiittymaanSijainninMukaan"
                && this.$store.getters.rightSlot !== "Infokartat"
                && this.$store.getters.rightSlot !== "KiinteanVerkonSaatavuusRuuduilla"
                && this.$store.getters.rightSlot !== "TVPeittoalueet"
                && this.$store.getters.rightSlot !== "RadioPeittoalueet"
                && this.$store.getters.rightSlot !== "AntenniTVSaatavuus"
                && this.$store.getters.rightSlot !== "RadioasemienKuuluvuus"
                && this.$store.getters.rightSlot !== "BittimittariVuorokaudenaikaanPohjautuvatRuudut"
        }

        get displayType(): string {
            return this.$store.getters.displayType
        }

        get displayLarge(): string {
            return this.$store.state.displayLarge
        }

        get displayExtraLarge(): string {
            return this.$store.state.displayExtraLarge
        }

        get displayMedium(): string {
            return this.$store.state.displayMedium
        }

        get displaySmall(): string {
            return this.$store.state.displaySmall
        }

        get displayExtraSmall(): string {
            return this.$store.state.displayExtraSmall
        }

        get displaySmallOrExtraSmall(): boolean {
            return this.displayType === this.displaySmall || this.displayType === this.displayExtraSmall
        }

        // get selected area name by municipality/province number
        get selectedAreaName() {
            if (this.$store.getters.selectedAreaRadioButton === "kunta") {
                const municipalityNumber = this.$store.getters.selectedMunicipality
                const municipalities: Array<MunicipalitiesAndRegionsModel> = this.$store.getters.municipalitiesData
                const municipality = municipalities.find(mun => mun.kuntanumero === municipalityNumber)

                if (this.$store.getters.activeLang === "sv") {
                    return municipality?.namn ?? ""
                }

                return municipality?.nimi ?? ""
            }
            else if (this.$store.getters.selectedAreaRadioButton === "maakunta") {
                const provinceNumber = this.$store.getters.selectedProvince
                const provinces: Array<MunicipalitiesAndRegionsModel> = this.$store.getters.regionsData
                const province = provinces.find(pro => pro.maakuntanumero === provinceNumber)

                if (this.$store.getters.activeLang === "sv") {
                    return province?.namn ?? ""
                }

                return province?.nimi ?? ""
            }

            return ""
        }
    }
</script>

<style scoped>
    .right-slot-header {
        padding: 0px 20px 10px 20px;
    }

    h2.right-slot-heading {
        display: flex;
        flex-direction: column;
        line-height: 1.5;
    }

    #app h2.heading-space {
        margin-bottom: 10px;
    }

    .header-span-spacing {
        margin-bottom: 20px !important;
    }

    .header-last-span-spacing {
        margin-bottom: 10px !important;
    }

</style>
